import { newrelic } from "@jti/fe-clients";
import { getConfig } from "@jti/fe-common";
import type { SnpApiContact } from "@jti/rest-api-types";

import { createLegacyApiWarningAttributes, getIsEvo } from "../../utils";

import { SnpApiEvo } from "./SnpApiEvo";
import { SnpApiLegacy } from "./SnpApiLegacy";

/**
 * Subscribers Notifications Proxy API
 */

export class SnpApi {
  static init(): SnpApiContact {
    const config = getConfig();

    if (config.USE_EVO_ONLY) {
      return new SnpApiEvo(config.EVO_DOMAIN, config.EVO_TENANT, config["X-RECAPTCHA-ID"]);
    }

    if (getIsEvo(config.SNP_URL)) {
      return new SnpApiEvo(config.SNP_URL, config.SNP_X_DES_AK_TENANT_TOKEN, config["X-RECAPTCHA-ID"]);
    }
    newrelic.sendWarning(
      "SnpApiLegacy initialized - legacy API client in use",
      createLegacyApiWarningAttributes(config, config.SNP_URL)
    );

    return new SnpApiLegacy(config.SNP_URL, config.SNP_X_DES_AK_TENANT_TOKEN);
  }
}
